export default "__VITE_ASSET__DwRgA77p__"